import { render, staticRenderFns } from "./NewCard.vue?vue&type=template&id=b0768764&scoped=true"
import script from "./NewCard.vue?vue&type=script&lang=js"
export * from "./NewCard.vue?vue&type=script&lang=js"
import style0 from "./NewCard.vue?vue&type=style&index=0&id=b0768764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0768764",
  null
  
)

export default component.exports